import React from 'react';
import { 
  Star, 
  MenuBook, 
  Handshake, 
  Lightbulb, 
  Public, 
  Favorite 
} from '@mui/icons-material';
import schoolBuildingImg from '../images/schoolBuilding/schoolBuilding.jpg';
import principalImg from '../images/principal/principal.jpg';

const About = () => {
  return (
    <section id="about" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">About Our School</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Discover the story behind Moxie Master Public School and our commitment to excellence in education</p>
        </div>

        <div className="flex flex-col gap-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-blue-800 mb-6 text-3xl font-semibold">Welcome to Moxie Master Public School</h3>
              <p className="text-base md:text-lg leading-relaxed mb-6">
                Founded in 2008, Moxie Master Public School has been at the forefront of 
                educational excellence for over 15 years. We are committed to providing a nurturing 
                environment where students can develop academically, socially, and emotionally.
              </p>
              <p className="text-base md:text-lg leading-relaxed mb-0">
                Our school combines traditional values with modern educational approaches, ensuring 
                that every student receives a well-rounded education that prepares them for the 
                challenges of the 21st century.
              </p>
            </div>
            <div className="flex justify-center">
              <img
                src={schoolBuildingImg}
                alt="School Building"
                className="w-full h-72 object-cover rounded-xl shadow-lg"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-10 rounded-xl shadow-md text-center transition-transform hover:-translate-y-1 hover:shadow-lg">
              <div className="text-4xl mb-6 text-blue-700"><MenuBook fontSize="inherit" /></div>
              <h4 className="text-blue-800 mb-4 text-xl font-semibold">Our Vision</h4>
              <p className="text-gray-600 leading-relaxed">To empower students to become lifelong learners, responsible citizens, and leaders in a global society.</p>
            </div>
            <div className="bg-white p-10 rounded-xl shadow-md text-center transition-transform hover:-translate-y-1 hover:shadow-lg">
              <div className="text-4xl mb-6 text-blue-700"><Handshake fontSize="inherit" /></div>
              <h4 className="text-blue-800 mb-4 text-xl font-semibold">Our Mission</h4>
              <p className="text-gray-600 leading-relaxed">To provide a nurturing and innovative learning environment that fosters academic excellence, character development, and global awareness.</p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-12 shadow-md">
            <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-8 items-start">
              <div className="flex justify-center">
                <img
                  src={principalImg}
                  alt="Principal"
                  className="w-64 h-64 rounded-full object-cover shadow-lg"
                />
              </div>
              <div>
                <h3 className="text-blue-800 text-2xl font-semibold mb-4">Principal's Message</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  "At Moxie Master Public School, we believe that every child has the 
                  potential to achieve greatness. Our dedicated team of educators works tirelessly 
                  to create an environment where students feel valued, inspired, and motivated to 
                  reach their full potential."
                </p>
                <p className="text-gray-700 leading-relaxed mb-6">
                  "We focus not only on academic excellence but also on character development, 
                  leadership skills, and global awareness. Our students graduate with the knowledge, 
                  skills, and values needed to succeed in an ever-changing world."
                </p>
                <div className="mt-6">
                  <strong className="block text-blue-900 text-lg">Dr. Sarah Johnson</strong>
                  <span className="block text-gray-500 text-sm">Principal, Moxie Master Public School</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12">
            <h3 className="text-blue-800 text-2xl font-semibold mb-6 text-center">Our Core Values</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
              <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow-md">
                <div className="text-3xl text-blue-700 mb-4"><Star fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Excellence</h4>
                <p className="text-gray-600 text-center text-sm">Striving for the highest standards in academics and personal growth.</p>
              </div>
              <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow-md">
                <div className="text-3xl text-blue-700 mb-4"><Lightbulb fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Innovation</h4>
                <p className="text-gray-600 text-center text-sm">Encouraging creativity, curiosity, and forward-thinking solutions.</p>
              </div>
              <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow-md">
                <div className="text-3xl text-blue-700 mb-4"><Favorite fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Compassion</h4>
                <p className="text-gray-600 text-center text-sm">Fostering empathy, kindness, and respect for all individuals.</p>
              </div>
              <div className="flex flex-col items-center bg-white rounded-xl p-8 shadow-md">
                <div className="text-3xl text-blue-700 mb-4"><Public fontSize="inherit" /></div>
                <h4 className="text-blue-900 font-semibold mb-2">Global Citizenship</h4>
                <p className="text-gray-600 text-center text-sm">Preparing students to thrive in a diverse and interconnected world.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 